<template>
  <div class="head">
    <div class="breadcrumbs">
      <router-link to="/main">Главная B2B</router-link> - {{page.title}}
    </div>
    <News />
    <div class="panel_title">{{page.title}}</div>
  </div>
</template>

<script>
import News from '@/views/News.vue'
export default {
  name: "Head",
  props: ['page'],
  components: {
    News,
  },
}
</script>

<style scoped>

</style>